import styled from 'styled-components';
import theme from '../../../theme';
import SmallLabel from '../SmallLabel/SmallLabel';

const Tag = styled(SmallLabel)`
  display: inline-block;
  padding: 0 4px;
  border-radius: 1px;
  background: ${theme.colors.medium};
  color: ${theme.colors.white};
`;

export default Tag;
